import { Col, Descriptions, Row } from "antd";
import Mapbox from "components/map/Mapbox";

const DefaultWorkerAddress = ({ data }) => {
  return (
    <>
      <Row>
        <Col span={data?.latitude ? 18 : 24}>
          <Descriptions bordered column={1} size={"large"}>
            <Descriptions.Item label="آدرس">
              {data?.address ?? "اطلاعات وارد نشده"}
            </Descriptions.Item>
            <Descriptions.Item label="استان - شهر - ناحیه">
              {data?.district ?? "اطلاعات وارد نشده"}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        {data?.latitude ? (
          <Col span={6}>
            <Mapbox
              coordinate={[data?.latitude, data?.longitude]}
              draggable={false}
              noSearchable
              readonly
            />
          </Col>
        ) : null}
      </Row>
    </>
  );
};

export default DefaultWorkerAddress;
